var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDarkbackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 310,
    viewBox: "0 0 310 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.674 95H158.588C152.798 95.0181 147.068 96.1789 141.726 98.4163C136.384 100.654 131.534 103.924 127.453 108.039C123.373 112.155 120.142 117.036 117.944 122.403C115.747 127.771 114.627 133.519 114.648 139.32V157.313C114.642 158.762 114.064 160.151 113.039 161.174C112.014 162.197 110.626 162.771 109.18 162.771V162.771C107.753 162.772 106.383 162.214 105.361 161.216C104.339 160.218 103.748 158.86 103.712 157.431L103.417 143.636L85.2819 206.5L114.648 214.738H146.708C172.789 214.738 183.941 187.838 183.941 167.994V135.793V129.27C183.939 128.544 184.079 127.824 184.355 127.152C184.63 126.481 185.036 125.87 185.547 125.355C186.059 124.841 186.667 124.433 187.336 124.154C188.006 123.876 188.724 123.732 189.449 123.732C190.911 123.738 192.312 124.323 193.344 125.361C194.376 126.399 194.956 127.805 194.956 129.27",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8212 95.808C98.2323 92.1622 114.597 101.483 114.597 114.45V173.571C114.613 182.784 117.572 191.75 123.04 199.157C128.507 206.565 136.198 212.024 144.985 214.738H114.597C86.667 214.738 59.8976 191.858 59.8976 163.895V111.81C60.0131 110.259 59.5881 108.716 58.695 107.443C57.8019 106.171 56.496 105.249 55 104.834L85.8212 95.808Z",
    fill: "url(#paint0_linear_314_1751)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.336 214.738C252.897 214.228 251.651 213.283 250.77 212.034C249.889 210.784 249.417 209.291 249.419 207.762V144.897C249.419 131.664 244.172 118.972 234.832 109.615C225.493 100.257 212.826 95 199.617 95H165.138C173.907 97.7353 181.573 103.207 187.019 110.616C192.465 118.026 195.404 126.985 195.408 136.187V191.366C195.403 194.431 196.001 197.468 197.168 200.302C198.334 203.136 200.047 205.712 202.208 207.883C204.369 210.054 206.936 211.776 209.762 212.952C212.587 214.129 215.617 214.735 218.677 214.738H254.336Z",
    fill: "url(#paint1_linear_314_1751)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_314_1751",
    x1: 135.307,
    y1: 214.989,
    x2: 72.6709,
    y2: 99.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB23DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_314_1751",
    x1: 186.183,
    y1: 86.3608,
    x2: 249.057,
    y2: 202.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E53F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AF0BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkbackground);
export default __webpack_public_path__ + "static/media/icon_darkbackground.3f79f15c45662ca9f016bbbec3a48dce.svg";
export { ForwardRef as ReactComponent };